export const SET_SMSMESSAGES_PAGINATION_STATE =
  "SET_SMSMESSAGES_PAGINATION_STATE";
export const SET_GROUPS_PAGINATION_STATE = "SET_GROUPS_PAGINATION_STATE";
export const SET_GROUPCONTACTS_PAGINATION_STATE = "SET_GROUPCONTACTS_PAGINATION_STATE";
export const SET_OPTINS_PAGINATION_STATE = "SET_OPTINS_PAGINATION_STATE";
export const SET_PAINDING_PAGINATION_STATE = "SET_PAINDING_PAGINATION_STATE";
export const SET_OPTOUT_PAGINATION_STATE = "SET_OPTOUT_PAGINATION_STATE";
export const SET_INVALID_PAGINATION_STATE = "SET_INVALID_PAGINATION_STATE";
export const SET_SENDHISTORY_PAGINATION_STATE =
  "SET_SENDHISTORY_PAGINATION_STATE";
export const SET_SHEDULEDSEND_PAGINATION_STATE =
  "SET_SHEDULEDSEND_PAGINATION_STATE";
export const SET_RECIPIENTS_PAGINATION_STATE =
  "SET_RECIPIENTS_PAGINATION_STATE";
export const GET_PAGINATION_STATE = "GET_PAGINATION_STATE";
export const SET_SUCCSEND_MESSAGESTATISTICS_STATE = "SET_SUCCSEND_MESSAGESTATISTICS_STATE";
export const SET_TEXTRESPONSE_PAGINATION_STATE = "SET_TEXTRESPONSE_PAGINATION_STATE";
export const SET_PAYMENT_SHORTLINK_PAGINATION_STATE = "SET_PAYMENT_SHORTLINK_PAGINATION_STATE";
export const SET_ACTIVEEVENTS_PAGINATION_STATE = "SET_ACTIVEEVENTS_PAGINATION_STATE";
export const SET_ENDEDEVENTS_PAGINATION_STATE = "SET_ENDEDEVENTS_PAGINATION_STATE";
export const CLEAR_PAGINATION_STATE = "CLEAR_PAGINATION_STATE";
